// This file is auto-generated by ./bin/rails stimulus:manifest:update
// Run that command whenever you add a new controller or create them with
// ./bin/rails generate stimulus controllerName

import { application } from "./application"

import Select2Controller from "./select2_controller"
application.register("select2", Select2Controller)

import DatePickerController from "./datepicker_controller"
application.register("datepicker", DatePickerController)

import AlertCloseController from "./alert_close_controller"
application.register("alert_close", AlertCloseController)

// Con GUION y no con guion bajo como sus vecinos, a proposito: Rails corre .dasherize
// sobre las claves del hash `data:`, asi que un data: { "bulk_select-target": ... } sale
// al HTML como data-bulk-select-target y Stimulus, que busca data-bulk_select-target,
// no encuentra el target. Los vecinos no lo sufren porque ninguno usa targets.
import BulkSelectController from "./bulk_select_controller"
application.register("bulk-select", BulkSelectController)
